import { render } from "./CustomRestaurantReceipt.vue?vue&type=template&id=50b7fb6f&scoped=true"
import script from "./CustomRestaurantReceipt.vue?vue&type=script&lang=js"
export * from "./CustomRestaurantReceipt.vue?vue&type=script&lang=js"

import "./CustomRestaurantReceipt.vue?vue&type=style&index=0&id=50b7fb6f&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b7fb6f"]])

export default __exports__